import React from 'react';
import AvailableItemsTableApp from "../Functionality/AvailableItemsTableApp";
import SearchSimple from "../../SearchSimples/SearchSimple";
import UserEmailPhoneCard from "./UserEmailPhoneCard";
import {getFullName} from "../../../Apis/functions";
import NotInformation from "../../NotInformation";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * Component that renders the available items table with search,
 * selection handling, and pagination support.
 *
 * @param {Object} props - Component properties
 * @param {Function} props.setBodyForExport - Sets the request body for export functionality
 * @param {Function} props.setSearch - Triggers advanced search behavior
 * @param {Function} props.setSimpleSearch - Triggers simple search behavior
 * @param {Array} props.selected - List of selected items
 * @param {*} props.option - Optional parameter to customize table behavior (e.g., filtering context)
 * @param {Object} props.results - Data source containing available items and pagination info
 * @param {Function} props.setResults - Updates the results state
 * @param {string} props.searchElement - Current search input value
 * @param {Function} props.setSearchElement - Updates the search input value
 * @param {string} props.labelRowsPerPage - Label for rows per page in pagination
 * @param {Function} props.onAdd - Callback executed when an item is added to the selected list
 * @param {string} props.tableNotInformationLegend - Message displayed when no data is available
 * @param {Function} props.tableBuildBody - Function to build request body for API calls
 * @param {Function} props.tableEndPoint - Endpoint function to fetch available items
 * @param {string} props.keyId - Unique identifier key for each item
 * @param {string} props.viewTypeName - View type identifier for rendering variations
 * @param {boolean} props.modified - Indicates if the data has been modified
 * @param {Function} props.setModified - Updates the modified state
 * @param {Function} props.renderAvailableItem - Function used to render each available item row
 * @returns {JSX.Element} Available items table component
 */
const AvailableItemsTable = (props) => {

    const {
        setBodyForExport,
        setSearch,
        setSimpleSearch,
        selected,
        option,
        results,
        setResults,
        searchElement,
        setSearchElement,
        labelRowsPerPage,
        onAdd,
        tableNotInformationLegend,
        tableBuildBody,
        tableEndPoint,
        keyId,
        viewTypeName,
        modified,
        setModified,
        renderAvailableItem,
        bottom,
        searchTitle='search_by_name_email_or_phone'
    } = props;


    const {
        t,
        pagination,
        rowsPerPage,
        elementRef,
        notInformationRef,
        getData
    } = AvailableItemsTableApp({
        option,
        results,
        setResults,
        searchElement,
        labelRowsPerPage,
        tableBuildBody,
        tableEndPoint,
        viewTypeName,
        modified,
        setModified,
        bottom
    });

    return (
        <div className={"mt-3"}>
            <SearchSimple
                id={"txt_aet_search_employees"}
                label={searchTitle}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
                callApi={() => getData(0, { searchElement})}
                resetApi={() => getData(0, { searchElement: ''})}
            />
            {results?.content?.length > 0
                ?
                <div className='panelTables-container custom-scrollbar' ref={elementRef}>
                    <div className='row m-0 p-0'>
                        {results?.content?.map((item, index) => {
                            const isDisabled = selected?.some(u => (u[keyId])  === item[keyId]);

                            return (
                                <div
                                    key={item[keyId] || index}
                                    className={`col-sm-12 col-md-6 m-0 p-0 mb-3 ${index % 2 === 1 ? 'pl-md-3' : ''} ${isDisabled ? '' : 'cursor-pointer'}`}
                                >
                                    {
                                        renderAvailableItem ?
                                            renderAvailableItem({ item, keyId, disabled:isDisabled, onAdd, selected })
                                            :
                                            <UserEmailPhoneCard
                                                item={{
                                                    [keyId]: item[keyId],
                                                    fullName: item?.fullName || getFullName(item?.name, item?.firstLastName, item?.secondLastName),
                                                    email: item?.email,
                                                    phoneNumber:item?.phoneNumber,
                                                    disabled:isDisabled
                                                }}
                                                onAdd={onAdd}
                                            />
                                    }
                                </div>
                            );
                        })}
                    </div>
                </div>
                :
                <NotInformation text={t(tableNotInformationLegend)} containerRef={notInformationRef} card={true} />
            }

            {pagination()}
        </div>
    );

}
export default AvailableItemsTable
